import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../utils/withDefaults';
const RootRoot = styled(Typography)(({
  theme
}) => ({
  color: theme.palette.grey[700],
  marginBottom: theme.spacing(1),
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 384
  }
}));
export const Root = withDefaults(RootRoot, {
  variant: 'Lato Caption'
});